/**
 * 접근 제어 공통 유틸리티 (formatStatus, formatDate, toast, getErrorMessage)
 */
import CarbonCodes from "../../../codes";

export default {
    methods: {
        formatStatus(status) {
            return CarbonCodes.status.getLabel(status);
        },
        formatDate(dateString) {
            if (!dateString) return "-";
            const date = new Date(dateString);
            return date.toLocaleDateString("ko-KR");
        },
        getErrorMessage(error, fallback = "작업에 실패했습니다.") {
            if (!error) return fallback;
            const msg =
                error.response?.data?.message ||
                error.response?.data?.data?.message ||
                (typeof error.response?.data === "string" ? error.response.data : null) ||
                error.message;
            return msg || fallback;
        },
        toastSuccess(message) {
            this.$bvToast.toast(message, { variant: "success", title: "완료" });
        },
        toastError(message) {
            this.$bvToast.toast(message, { variant: "danger", title: "오류" });
        },
    },
};
